export var UserType;
(function (UserType) {
    UserType["TEACHER"] = "TEACHER";
    UserType["HOMESCHOOLER"] = "HOMESCHOOLER";
    UserType["OTHER"] = "OTHER";
})(UserType || (UserType = {}));
export var UserClassRoles;
(function (UserClassRoles) {
    UserClassRoles["PRIMARY_TEACHER"] = "PRIMARY_TEACHER";
    UserClassRoles["CO_TEACHER"] = "CO_TEACHER";
    UserClassRoles["STAFF_OF"] = "STAFF_OF";
})(UserClassRoles || (UserClassRoles = {}));
export var UserNotificationName;
(function (UserNotificationName) {
    UserNotificationName["SHARE_LALILO"] = "shareLalilo";
    UserNotificationName["STAR_EMAIL"] = "starEmail";
})(UserNotificationName || (UserNotificationName = {}));
//# sourceMappingURL=user.js.map